import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import AssetsCreditDetails from '../../components/assets-details-wrapper/assets-credit-details';
import AppPageMain from '../../modules/app-page/app-page--main';
import PageHeader from '../../modules/page-header';
import { getCreditDetails } from '../../store/actions/credit-details';
import { RootState } from '../../types';

const CreditDetailsPage: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isHistory = history.location.state?.isHistory;

  const accountId = useSelector((state: RootState) => state.auth.account.id);
  const asset = useSelector(
    (state: RootState) => state.creditDetails.data.details
  );

  useEffect(() => {
    dispatch(getCreditDetails({ accountId, id: history.location.state.id }));
  }, [history]);

  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={
                isHistory
                  ? [
                      { link: '/history', title: 'Операции' },
                      { link: '/history', title: 'Займы' },
                    ]
                  : [
                      { link: '/assets', title: 'Активы' },
                      { link: '/assets', title: 'Займы' },
                    ]
              }
              iconType={isHistory ? 'history' : 'assets'}
              tabName="loans"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <AssetsCreditDetails
              id={asset.id}
              onClose={() =>
                history.replace(isHistory ? '/history' : '/assets')
              }
              status={asset.status}
              sum={asset.amount}
              deadlineAt={asset.deadlineAt}
              info={{
                percent: asset.percent,
                appliedAt: asset.appliedAt,
                createdAt: asset.createdAt,
                amount: asset.amount,
                delta: asset.delta,
              }}
              asset={asset}
            />
          </div>
        </div>
      </div>
    </AppPageMain>
  );
};

export default CreditDetailsPage;
